module.exports = __webpack_public_path__ + "static/img/illustratepic_02_en.5636ce0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/illustratepic_02_en.png
// module id = Sf3H
// module chunks = 1